/**
 * Auto-discovers widgets under src/widgets/<type>/:
 *   src/widgets/sensorDataView/index.js
 *   src/widgets/sensorDataView/defaultConfig.json
 *   src/widgets/sensorManager/index.js
 *   src/widgets/sensorManager/defaultConfig.json
 *   ...
 *
 * The folder name becomes the widget `type` key used in your layout items.
 * Produces: { [type]: { Component, defaultConfig } }
 *
 * Uses require.context, which CRA's webpack config supports natively —
 * no extra build setup needed.
 */

const componentModules = require.context('../widgets', true, /^\.\/[^/]+\/index\.js$/);
const defaultConfigModules = require.context('../widgets', true, /^\.\/[^/]+\/defaultConfig\.json$/);

const FOLDER_NAME_RE = /^\.\/([^/]+)\//;

const widgetRegistry = {};

componentModules.keys().forEach((key) => {
  const match = key.match(FOLDER_NAME_RE);
  if (!match) return;
  const type = match[1];
  const mod = componentModules(key);

  widgetRegistry[type] = {
    ...widgetRegistry[type],
    Component: mod.default || mod,
  };
});

defaultConfigModules.keys().forEach((key) => {
  const match = key.match(FOLDER_NAME_RE);
  if (!match) return;
  const type = match[1];
  const config = defaultConfigModules(key);

  widgetRegistry[type] = {
    ...widgetRegistry[type],
    defaultConfig: config.default || config,
  };
});

export default widgetRegistry;